import React from 'react';

import CertificateCard from '../shared/CertificateCard';
import { useShippingCompany } from '../shared/context';

export default function Certificate() {
  const shippingCompany = useShippingCompany();

  return (
    <CertificateCard personId={shippingCompany.data?.id} loading={shippingCompany.isFetching} />
  );
}
